import { IShelfTestQuestionModelState, IShelfTestResponseValidation, ShelfTestQuestionModelTypes } from './types'
import { IQuestionModelConstructor, QuestionType } from '../types'
import BaseQuestionModel from '../BaseQuestionModel'

const ShelfTestQuestionModel: IQuestionModelConstructor<ShelfTestQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<ShelfTestQuestionModelTypes, IShelfTestQuestionModelState>({
    questionType: QuestionType.SHELF_TEST,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse,
    namedFrames: ['question']
  })
  return model
}

function submitResponse({ response, questionSchema }: IShelfTestQuestionModelState) {
  const naAnswer = questionSchema.answers.find(a => a.na)
  const naChecked = response.answers.some(r => r.id == naAnswer?.id && r.v > 0)
  return response.answers
    .filter(answer => answer.v > 0 && (naChecked ? answer.id == naAnswer.id : true))
    .map(answer => {
      return { id: answer.id, v: answer.v }
    })
}

function initState(state: IShelfTestQuestionModelState): IShelfTestQuestionModelState {
  state.response = {
    answers: state.questionSchema.answers.map(a => {
      return { id: a.id, v: 0, price: (a.discounted_price ? a.discounted_price : a.price) || 0 }
    }),
    clicked: state.questionSchema.na
  }
  state.responseValidation = { valid: false }
  return state
}

function validateResponse({
  responseValidation,
  response,
  questionSchema
}: IShelfTestQuestionModelState): IShelfTestResponseValidation {
  if ('ecommerce' == questionSchema.store) {
    return {
      valid: questionSchema.na
        ? response.answers.some(r => r.v > 0)
        : response.clicked || response.answers.some(r => r.v > 0)
    }
  }
  if (responseValidation) return responseValidation

  return {
    valid: false
  }
}

export default ShelfTestQuestionModel
